import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "../../assets/css/AllBooking.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import config from "../../config";
import { singleProfile } from "../../Constant";
import {
    GetBookingsAction,
    LoadMoreBookingsAction,
} from "../../redux/actions/bookings";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faClock,
    faPaperPlane,
    faStar,
} from "@fortawesome/free-solid-svg-icons";
import { START_LOADER, STOP_LOADER } from "../../redux/actions/types";
import Swal from "sweetalert2";
import { text } from "@fortawesome/fontawesome-svg-core";

function AllBooking({
    startLoading,
    stopLoading,
    auth,
    bookings,
    getPendingBookings,
    getOngoingBookings,
    getCompletedBookings,
    getCancelledBookings,
    loadMorePendingBookings,
    loadMoreOngoingBookings,
    loadMoreCompletedBookings,
    loadMoreCancelledBookings,
}) {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getPendingBookings().then(() => {
            getOngoingBookings().then(() => {
                getCompletedBookings().then(() => {
                    getCancelledBookings().then(() => {
                        setLoading(false);
                    });
                });
            });
        });
    }, []);

    const cancel = async (id) => {
        try {
            const result = await Swal.fire({
                icon: "warning",
                title: "Confirmation",
                text: "Are you sure you want to cancel this booking?",
                showConfirmButton: true,
                showDenyButton: true,
                denyButtonText: "No",
                confirmButtonText: "Yes",
            });
            if (result.isConfirmed) {
                startLoading();
                const res = await config.getApi(
                    config.services.cancelJob(id),
                    config.bearerHeaders(auth.token)
                );
                stopLoading();
                if (res) {
                    Swal.fire({
                        icon: "success",
                        title: "Job Cancelled",
                        text: "Job has been Succesfully Cancelled!",
                    });
                    await getPendingBookings();
                    await getOngoingBookings();
                    await getCompletedBookings();
                    await getCancelledBookings();
                }
            }
        } catch (e) {
            stopLoading();
            console.log(e);
        }
    };

    if (loading) {
        return <div />;
    }
    return (
        <>
            <Header />
            <section className="all_bookings">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="bookings">
                                <div className="heading_wrapper">
                                    <h4>All Bookings</h4>
                                    <p>
                                        We cater to a wide range of caregiving
                                        jobs with the help of our specialist
                                        caregivers and home-helpers.
                                    </p>
                                </div>
                                <ul
                                    className="nav nav-tabs"
                                    id="myTab"
                                    role="tablist"
                                >
                                    <li className="nav-item">
                                        <a
                                            className="nav-link active"
                                            id="ongoing-tab"
                                            data-toggle="tab"
                                            href="#ongoing"
                                            role="tab"
                                            aria-controls="ongoing"
                                            aria-selected="true"
                                        >
                                            Ongoing Jobs
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className="nav-link"
                                            id="pending-tab"
                                            data-toggle="tab"
                                            href="#pending"
                                            role="tab"
                                            aria-controls="pending"
                                            aria-selected="false"
                                        >
                                            Pending Requests
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className="nav-link"
                                            id="completed-tab"
                                            data-toggle="tab"
                                            href="#completed"
                                            role="tab"
                                            aria-controls="completed"
                                            aria-selected="false"
                                        >
                                            Completed Jobs
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className="nav-link"
                                            id="cancelled-tab"
                                            data-toggle="tab"
                                            href="#cancelled"
                                            role="tab"
                                            aria-controls="cancelled"
                                            aria-selected="false"
                                        >
                                            Cancelled Jobs
                                        </a>
                                    </li>
                                    {/* <li className="nav-item">
                                        <a
                                            className="nav-link"
                                            id="upcoming-tab"
                                            data-toggle="tab"
                                            href="#upcoming"
                                            role="tab"
                                            aria-controls="upcoming"
                                            aria-selected="false"
                                        >
                                            Upcoming Jobs
                                        </a>
                                    </li> */}
                                </ul>
                                <div className="tab-content" id="myTabContent">
                                    <div
                                        className="tab-pane fade show active"
                                        id="ongoing"
                                        role="tabpanel"
                                        aria-labelledby="ongoing-tab"
                                    >
                                        <div className="tabel-reposnive">
                                            <table className="table">
                                                <thead>
                                                    <tr className="topbar">
                                                        <th className="job">
                                                            Job
                                                        </th>
                                                        <th className="client-name">
                                                            Client name
                                                        </th>
                                                        <th className="client-status">
                                                            Status
                                                        </th>
                                                        <th className="date">
                                                            Date
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {bookings.ongoing.data.map(
                                                        (booking) => {
                                                            return (
                                                                <tr
                                                                    key={
                                                                        booking.id
                                                                    }
                                                                >
                                                                    <td className="job">
                                                                        <h6 className="job_name">
                                                                            {
                                                                                booking.title
                                                                            }
                                                                        </h6>
                                                                        <span className="job_type">
                                                                            {
                                                                                booking
                                                                                    .service
                                                                                    .title
                                                                            }
                                                                        </span>
                                                                    </td>
                                                                    <td className="client-name">
                                                                        <div className="client_box for-responsive">
                                                                            <figure>
                                                                                <img
                                                                                    src={
                                                                                        booking.user_id ==
                                                                                        auth
                                                                                            .user
                                                                                            .id
                                                                                            ? config.returnImage(
                                                                                                  booking.care_giver
                                                                                              )
                                                                                            : config.returnImage(
                                                                                                  booking.user
                                                                                              )
                                                                                    }
                                                                                    alt=""
                                                                                />
                                                                            </figure>
                                                                            <p className="name">
                                                                                {booking.user_id ==
                                                                                auth
                                                                                    .user
                                                                                    .id
                                                                                    ? booking
                                                                                          .care_giver
                                                                                          .full_name
                                                                                    : booking
                                                                                          .user
                                                                                          .full_name}
                                                                            </p>
                                                                        </div>
                                                                    </td>
                                                                    <td className="client-status">
                                                                        {booking.status ==
                                                                        config
                                                                            .jobConstants
                                                                            .ACCEPTED ? (
                                                                            <h6
                                                                                style={{
                                                                                    color: "blue",
                                                                                }}
                                                                            >
                                                                                {
                                                                                    booking.status
                                                                                }
                                                                            </h6>
                                                                        ) : (
                                                                            <h6
                                                                                style={{
                                                                                    color: "green",
                                                                                }}
                                                                            >
                                                                                {
                                                                                    booking.status
                                                                                }
                                                                            </h6>
                                                                        )}
                                                                        {/* <h6>
                                                                            {
                                                                                booking.status
                                                                            }
                                                                        </h6> */}
                                                                    </td>
                                                                    <td className="date">
                                                                        <div className="buttons-group">
                                                                            <p className="job_date">
                                                                                {moment(
                                                                                    booking.created_at
                                                                                ).format(
                                                                                    "DD MMM, YYYY"
                                                                                )}
                                                                                {/* 28
                                                                            Aug
                                                                            2021 */}
                                                                            </p>

                                                                            {/*{ booking.user_id == auth.user.id && booking.status == "Accepted" && (*/}
                                                                            {/*        <button*/}
                                                                            {/*            onClick={() =>*/}
                                                                            {/*                cancel(*/}
                                                                            {/*                    booking.id*/}
                                                                            {/*                )*/}
                                                                            {/*            }*/}
                                                                            {/*            style={{*/}
                                                                            {/*                marginLeft: 3,*/}
                                                                            {/*            }}*/}
                                                                            {/*            type="button"*/}
                                                                            {/*            className="btn view_details"*/}
                                                                            {/*        >*/}
                                                                            {/*            Cancel*/}
                                                                            {/*            Booking*/}
                                                                            {/*        </button>*/}
                                                                            {/*)}*/}

                                                                            <Link
                                                                                to={`/job-detail/${booking.id}`}
                                                                                className="btn view_details"
                                                                            >
                                                                                View
                                                                                Details
                                                                            </Link>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="total_data">
                                            <div className="showing_results">
                                                <p>
                                                    Showing{" "}
                                                    {bookings.ongoing.from || 0}{" "}
                                                    of{" "}
                                                    {bookings.ongoing.to || 0}{" "}
                                                    Jobs Results
                                                </p>
                                            </div>
                                            {bookings.ongoing.next_page_url ? (
                                                <div className="show_more_btn">
                                                    <button
                                                        className="btn"
                                                        onClick={
                                                            loadMoreOngoingBookings
                                                        }
                                                    >
                                                        Show More
                                                    </button>
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div
                                        className="tab-pane fade"
                                        id="pending"
                                        role="tabpanel"
                                        aria-labelledby="pending-tab"
                                    >
                                        <div className="tabel-reposnive">
                                            <table className="table">
                                                <thead>
                                                    <tr className="topbar">
                                                        <th className="job">
                                                            Job
                                                        </th>
                                                        <th className="client-name">
                                                            Client name
                                                        </th>
                                                        <th className="client-status">
                                                            Status
                                                        </th>
                                                        <th className="date">
                                                            Date
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {bookings.pending.data.map(
                                                        (booking) => (
                                                            <tr
                                                                key={booking.id.toString()}
                                                            >
                                                                <td className="job">
                                                                    <h6 className="job_name">
                                                                        {
                                                                            booking.title
                                                                        }
                                                                    </h6>
                                                                    <span className="job_type">
                                                                        {
                                                                            booking
                                                                                .service
                                                                                .title
                                                                        }
                                                                    </span>
                                                                </td>
                                                                <td className="client-name">
                                                                    <div className="client_box">
                                                                        <figure>
                                                                            <img
                                                                                src={
                                                                                    booking.user_id ==
                                                                                    auth
                                                                                        .user
                                                                                        .id
                                                                                        ? config.returnImage(
                                                                                              booking.care_giver
                                                                                          )
                                                                                        : config.returnImage(
                                                                                              booking.user
                                                                                          )
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        </figure>
                                                                        <p className="name">
                                                                            {booking.user_id ==
                                                                            auth
                                                                                .user
                                                                                .id
                                                                                ? booking
                                                                                      .care_giver
                                                                                      .full_name
                                                                                : booking
                                                                                      .user
                                                                                      .full_name}
                                                                        </p>
                                                                    </div>
                                                                </td>
                                                                <td className="client-status">
                                                                    <h6>
                                                                        {
                                                                            booking.status
                                                                        }
                                                                    </h6>
                                                                </td>
                                                                <td className="date">
                                                                    <div className="buttons-group">
                                                                        <p className="job_date">
                                                                            {moment(
                                                                                booking.created_at
                                                                            ).format(
                                                                                "DD MMM, YYYY"
                                                                            )}
                                                                        </p>
                                                                        <Link
                                                                            to={`/job-detail/${booking.id}`}
                                                                            className="btn view_details"
                                                                        >
                                                                            View
                                                                            Details
                                                                        </Link>
                                                                        {booking.user_id ==
                                                                            auth
                                                                                .user
                                                                                .id && (
                                                                            <button
                                                                                onClick={() =>
                                                                                    cancel(
                                                                                        booking.id
                                                                                    )
                                                                                }
                                                                                style={{
                                                                                    marginLeft: 3,
                                                                                }}
                                                                                type="button"
                                                                                className="btn view_details"
                                                                            >
                                                                                Cancel
                                                                                Booking
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="total_data">
                                            <div className="showing_results">
                                                <p>
                                                    Showing{" "}
                                                    {bookings.pending.from || 0}{" "}
                                                    of{" "}
                                                    {bookings.pending.to || 0}{" "}
                                                    Jobs Results
                                                </p>
                                            </div>
                                            {bookings.pending.next_page_url ? (
                                                <div className="show_more_btn">
                                                    <button
                                                        className="btn"
                                                        onClick={
                                                            loadMorePendingBookings
                                                        }
                                                    >
                                                        Show More
                                                    </button>
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div
                                        className="tab-pane fade"
                                        id="completed"
                                        role="tabpanel"
                                        aria-labelledby="completed-tab"
                                    >
                                        <div className="tabel-reposnive">
                                            <table className="table">
                                                <thead>
                                                    <tr className="topbar">
                                                        <th className="job">
                                                            Job
                                                        </th>
                                                        <th className="client-name">
                                                            Client name
                                                        </th>
                                                        <th className="client-status">
                                                            Status
                                                        </th>
                                                        <th className="date">
                                                            Date
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {bookings.completed.data.map(
                                                        (booking) => (
                                                            <tr
                                                                key={booking.id.toString()}
                                                            >
                                                                <td className="job">
                                                                    <h6 className="job_name">
                                                                        {
                                                                            booking.title
                                                                        }
                                                                    </h6>
                                                                    <span className="job_type">
                                                                        {
                                                                            booking
                                                                                .service
                                                                                .title
                                                                        }
                                                                    </span>
                                                                </td>
                                                                <td className="client-name">
                                                                    <div className="client_box">
                                                                        <figure>
                                                                            <img
                                                                                src={
                                                                                    booking.user_id ==
                                                                                    auth
                                                                                        .user
                                                                                        .id
                                                                                        ? config.returnImage(
                                                                                              booking.care_giver
                                                                                          )
                                                                                        : config.returnImage(
                                                                                              booking.user
                                                                                          )
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        </figure>
                                                                        <p className="name">
                                                                            {booking.user_id ==
                                                                            auth
                                                                                .user
                                                                                .id
                                                                                ? booking
                                                                                      .care_giver
                                                                                      .full_name
                                                                                : booking
                                                                                      .user
                                                                                      .full_name}
                                                                        </p>
                                                                    </div>
                                                                </td>
                                                                <td className="client-status">
                                                                    <h6>
                                                                        {
                                                                            booking.status
                                                                        }
                                                                    </h6>
                                                                </td>
                                                                <td className="date">
                                                                    <div className="buttons-group">
                                                                        <p className="job_date">
                                                                            {moment(
                                                                                booking.created_at
                                                                            ).format(
                                                                                "DD MMM, YYYY"
                                                                            )}
                                                                        </p>
                                                                        <Link
                                                                            to={`/job-detail/${booking.id}`}
                                                                            className="btn view_details"
                                                                        >
                                                                            View
                                                                            Details
                                                                        </Link>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="total_data">
                                            <div className="showing_results">
                                                <p>
                                                    Showing{" "}
                                                    {bookings.completed.from ||
                                                        0}{" "}
                                                    of{" "}
                                                    {bookings.completed.to || 0}{" "}
                                                    Jobs Results
                                                </p>
                                            </div>
                                            {bookings.completed
                                                .next_page_url ? (
                                                <div className="show_more_btn">
                                                    <button
                                                        className="btn"
                                                        onClick={
                                                            loadMoreCompletedBookings
                                                        }
                                                    >
                                                        Show More
                                                    </button>
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div
                                        className="tab-pane fade"
                                        id="cancelled"
                                        role="tabpanel"
                                        aria-labelledby="cancelled-tab"
                                    >
                                        <div className="tabel-reposnive">
                                            <table className="table">
                                                <thead>
                                                    <tr className="topbar">
                                                        <th className="job">
                                                            Job
                                                        </th>
                                                        <th className="client-name">
                                                            Client name
                                                        </th>
                                                        <th className="client-status">
                                                            Status
                                                        </th>
                                                        <th className="date">
                                                            Date
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {bookings.cancelled.data.map(
                                                        (booking) => (
                                                            <tr
                                                                key={booking.id.toString()}
                                                            >
                                                                <td className="job">
                                                                    <h6 className="job_name">
                                                                        {
                                                                            booking.title
                                                                        }
                                                                    </h6>
                                                                    <span className="job_type">
                                                                        {
                                                                            booking
                                                                                .service
                                                                                .title
                                                                        }
                                                                    </span>
                                                                </td>
                                                                <td className="client-name">
                                                                    <div className="client_box">
                                                                        <figure>
                                                                            <img
                                                                                src={
                                                                                    booking.user_id ==
                                                                                    auth
                                                                                        .user
                                                                                        .id
                                                                                        ? config.returnImage(
                                                                                              booking.care_giver
                                                                                          )
                                                                                        : config.returnImage(
                                                                                              booking.user
                                                                                          )
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        </figure>
                                                                        <p className="name">
                                                                            {booking.user_id ==
                                                                            auth
                                                                                .user
                                                                                .id
                                                                                ? booking
                                                                                      .care_giver
                                                                                      .full_name
                                                                                : booking
                                                                                      .user
                                                                                      .full_name}
                                                                        </p>
                                                                    </div>
                                                                </td>
                                                                <td className="client-status">
                                                                    <h6>
                                                                        {
                                                                            booking.status
                                                                        }
                                                                    </h6>
                                                                </td>
                                                                <td className="date">
                                                                    <div className="buttons-group">
                                                                        <p className="job_date">
                                                                            {moment(
                                                                                booking.created_at
                                                                            ).format(
                                                                                "DD MMM, YYYY"
                                                                            )}
                                                                        </p>
                                                                        <Link
                                                                            to={`/job-detail/${booking.id}`}
                                                                            className="btn view_details"
                                                                        >
                                                                            View
                                                                            Details
                                                                        </Link>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="total_data">
                                            <div className="showing_results">
                                                <p>
                                                    Showing{" "}
                                                    {bookings.cancelled.from ||
                                                        0}{" "}
                                                    of{" "}
                                                    {bookings.cancelled.to || 0}{" "}
                                                    Jobs Results
                                                </p>
                                            </div>
                                            {bookings.cancelled
                                                .next_page_url ? (
                                                <div className="show_more_btn">
                                                    <button
                                                        className="btn"
                                                        onClick={
                                                            loadMoreCancelledBookings
                                                        }
                                                    >
                                                        Show More
                                                    </button>
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="side_bar_box">
                                <div className="img_box">
                                    <figure>
                                        <img src="img/background.png" alt="" />
                                    </figure>
                                </div>
                                <div className="contentDv">
                                    <h5>Why Book With Us? </h5>
                                    <p>
                                        We update our information on a weekly or
                                        bi-weekly basis which means that you
                                        will always have the edge over your
                                        competitors.
                                    </p>
                                    <ul
                                        className="list"
                                        style={{ paddingBottom: 40 }}
                                    >
                                        <li>
                                            <FontAwesomeIcon
                                                color={config.starActiveColor}
                                                icon={faStar}
                                            />{" "}
                                            Stay updated with the industry
                                            standards.
                                        </li>
                                        <li>
                                            <FontAwesomeIcon
                                                color={config.starActiveColor}
                                                icon={faStar}
                                            />{" "}
                                            Tailored to your needs and values
                                        </li>
                                        <li>
                                            {/* <i
                                                className="fa fa-star"
                                                aria-hidden="true"
                                            ></i> */}
                                            <FontAwesomeIcon
                                                color={config.starActiveColor}
                                                icon={faStar}
                                            />{" "}
                                            Fully certified caregiver and
                                            home-helpers.
                                        </li>
                                    </ul>
                                    {/* <div className="button-group">
                                        <a href="#" className="btn">
                                            Loem Ipsum
                                        </a>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    bookings: state.bookings,
});

const mapDispatchToProps = (dispatch) => ({
    getPendingBookings: async () =>
        dispatch(await GetBookingsAction("Pending")),
    getOngoingBookings: async () =>
        dispatch(await GetBookingsAction("Progress")),
    getCompletedBookings: async () =>
        dispatch(await GetBookingsAction("Completed")),
    getCancelledBookings: async () =>
        dispatch(await GetBookingsAction("Cancelled")),
    loadMorePendingBookings: async () =>
        dispatch(await LoadMoreBookingsAction("Pending")),
    loadMoreOngoingBookings: async () =>
        dispatch(await LoadMoreBookingsAction("Progress")),
    loadMoreCompletedBookings: async () =>
        dispatch(await LoadMoreBookingsAction("Completed")),
    loadMoreCancelledBookings: async () =>
        dispatch(await LoadMoreBookingsAction("Cancelled")),
    startLoading: () => dispatch({ type: START_LOADER }),
    stopLoading: () => dispatch({ type: STOP_LOADER }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AllBooking);
